import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const NetworkModelsModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Network Models: OSI and TCP/IP"
    videos={[
      "https://www.youtube.com/embed/8OWNsRNKqyY",
      "https://www.youtube.com/embed/Y4sqlvv7egA",
      "https://www.youtube.com/embed/JHJQ6Ke2mYU",
      "https://www.youtube.com/embed/wvPe4Zb0tUA"
    ]}
    takeaways={[
      { text: "Learn about different layers and their functionalities." },
      { text: "Understand the differences between TCP/IP and OSI models." }
    ]}
    questions={[
      "Application X on computer A sends a message to application Y on computer B. Computers A and B are connected to LAN1 and LAN2, and both LANs are connected to Router R1. Explain the data processing that is performed in every layer with respect to the OSI reference model. Use a diagram to explain your answer.",
      "A company is hiring freshers to work on the Application layer and Transport layer. Identify any 4 protocols with their purpose, which the candidate has to be familiar to be eligible for the job.",
      "Consider two devices which want to communicate with each other. Analyse how TCP/IP model will be used in those two devices with neat sketch. Emphasize the functionalities of each layer and also present the names of encapsulated packets at each layer."
    ]}
    exampleVideos={[]}
  />
);
}

export default NetworkModelsModule;
